<template>
  <div>
    <div class="title_logo">
      <img src="../assets/stylus/image/logo_2.png" />
    </div>

    <div class="identity_class">
      <div>
        <p>
          校区:
          <el-tag style="margin-right:6px;" size="mini">
            {{ current }}
          </el-tag>

          <el-dropdown @command="handleSchool" trigger="click" size="mini">
            <el-link type="primary">切换</el-link>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in campusList"
                :key="index"
                :command="item"
              >
                {{ item.Name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </p>

        <p>
          身份:
          <el-tag
            v-if="userInfo.User.IsAdmin"
            style="margin-right:6px;"
            size="mini"
          >
            超级管理员
          </el-tag>

          <!-- <el-tag
            v-if="userInfo.user_role[0].Subject.Name == 'STUDENT'"
            style="margin-right:6px;"
            size="mini"
          >
            学生
          </el-tag> -->

          <span>
            <el-tag
              v-if="!userInfo.User.IsAdmin"
              style="margin-right:6px;"
              size="mini"
            >
              {{ identity_s }}
            </el-tag>

            <el-dropdown
              v-if="!userInfo.User.IsAdmin"
              @command="handleCommand"
              trigger="click"
              size="mini"
            >
              <el-link type="primary">切换</el-link>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in identity_arr"
                  :key="index"
                  :command="item"
                >
                  {{ item.Name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </p>
      </div>
    </div>

    <el-menu
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      @select="selectPath"
      :collapse="isCollapse"
      unique-opened
    >
      <!-- <div v-if="userInfo.user_role[0].Domain.Name == '游客'">
        <el-submenu index="5">
          <template slot="title">
            <i class="el-icon-folder-opened"></i>
            <span slot="title">作品管理</span>
          </template>
          <el-menu-item index="/my_works">
            <span slot="title">我的作品</span>
          </el-menu-item>
        </el-submenu>
      </div> -->

      <div>
        <el-menu-item index="/official" v-if="userInfo.User.IsAdmin">
          <i class="el-icon-eleme"></i>
          <span slot="title">官网管理</span>
        </el-menu-item>

        <el-menu-item index="/user" v-if="userInfo.User.IsAdmin">
          <i class="el-icon-user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>

        <el-menu-item
          index="/equipment"
          v-if="userInfo.User.IsAdmin == true || identity_s == '校长'"
        >
          <i class="el-icon-setting"></i>
          <span slot="title">设备管理</span>
        </el-menu-item>

        <el-menu-item index="/admin" v-if="userInfo.User.IsAdmin">
          <i class="el-icon-setting"></i>
          <span slot="title">校区管理</span>
        </el-menu-item>

        <el-menu-item index="/home" v-if="identity_s != '学生'">
          <i class="el-icon-school"></i>
          <span slot="title">教务管理</span>
        </el-menu-item>

        <el-submenu index="2" v-if="identity_s != '学生'">
          <template slot="title">
            <i class="el-icon-c-scale-to-original"></i>
            <span slot="title">校区课程</span>
          </template>
          <el-menu-item index="/viewCourse">
            <span slot="title">查看课程</span>
          </el-menu-item>
          <div v-if="userInfo.AccountPermission.CreateCourse">
            <el-menu-item index="/addAccount">
              <span slot="title">添加课程</span>
            </el-menu-item>
            <el-menu-item index="/addChapter">
              <span slot="title">添加章节</span>
            </el-menu-item>
            <el-menu-item index="/addHandout">
              <span slot="title">添加讲义</span>
            </el-menu-item>
            <el-menu-item index="/addPdf">
              <span slot="title">添加PDF</span>
            </el-menu-item>
            <el-menu-item index="/addZip">
              <span slot="title">添加压缩</span>
            </el-menu-item>
          </div>
        </el-submenu>

        <el-submenu index="4">
          <template slot="title">
            <i class="el-icon-folder-opened"></i>
            <span slot="title">试题管理</span>
          </template>
          <el-menu-item index="/practice" v-if="identity_s != '学生'">
            <span slot="title">练习/考试</span>
          </el-menu-item>
          <el-menu-item
            index="/campus_question_bank"
            v-if="identity_s != '学生'"
          >
            <span slot="title">校区题库</span>
          </el-menu-item>
          <el-menu-item index="/correction_topic" v-if="identity_s != '学生'">
            <span slot="title">批改试题</span>
          </el-menu-item>
        </el-submenu>

        <el-submenu index="5">
          <template slot="title">
            <i class="el-icon-folder-opened"></i>
            <span slot="title">作品管理</span>
          </template>
          <el-menu-item index="/my_works">
            <span slot="title">我的作品</span>
          </el-menu-item>
          <el-menu-item index="/student_works" v-if="identity_s != '学生'">
            <span slot="title">学生作品</span>
          </el-menu-item>
        </el-submenu>

        <!-- <el-menu-item
          index="/select_course?type=login_s"
          v-if="
            userInfo.user_role[0].Subject.Name == 'STUDENT' &&
            $route.query.type == 'login_s'
              ? true
              : false
          "
        >
          <i class="el-icon-c-scale-to-original"></i>
          <span slot="title">选课</span>
        </el-menu-item> -->

        <!-- <el-menu-item
          index="/course_info?type=login_s"
          v-if="
            identity_s == 'HEADMASTER' && $route.query.type == 'login_s'
              ? true
              : false
          "
        >
          <i class="el-icon-c-scale-to-original"></i>
          <span slot="title">课程信息</span>
        </el-menu-item> -->
      </div>
    </el-menu>

    <!-- 选择校区对话框 -->
    <el-dialog
      title="选择校区"
      :visible.sync="campus_isible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div>
        <el-select v-model="school_value" filterable placeholder="请选择">
          <el-option
            v-for="item in campusList"
            :key="item.Name"
            :label="item.Name"
            :value="item.Name"
          >
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="campus_isible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="campus_determine">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../store";
import { getSchool } from "@/api/admin.js";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  data() {
    return {
      asideMenu: [],
      isCollapse: false,
      campus_isible: false,
      campusList: [],
      // selectCampus: "", //选中的校区
      // selectCampus_name: "",
      school_value: "",
      schoolList: [],
      identity: [],
      identity_s: "",
      identity_arr: [],
    };
  },

  created() {
    let list = [];
    // this.identity_s = JSON.parse(sessionStorage.getItem("role"));
    if (this.userInfo.User.IsAdmin) {
      getSchool().then((res) => {
        this.campusList = res.data;
        if (this.current == "登录") {
          store.dispatch("current/campus", this.campusList[0].Name);
          localStorage.setItem("school_id", this.campusList[0].Id);
        }
      });
    } else {
      this.userInfo.SchoolRoles.forEach((res, i) => {
        list.push(res.School);
        // 数组对象去重
        const strings = list.map((item) => JSON.stringify(item));
        const removeDupList = [...new Set(strings)];
        this.campusList = removeDupList.map((item) => JSON.parse(item));

        if (this.current == "登录") {
          store.dispatch("current/campus", this.campusList[0].Name);
          localStorage.setItem("school_id", this.campusList[0].Id);
        }

        if (res.School.Name == this.current) {
          this.identity_arr.push(res.Role);
          if (!JSON.parse(sessionStorage.getItem("role"))) {
            this.identity_s = this.identity_arr[0].Name;
          } else {
            this.identity_s = JSON.parse(sessionStorage.getItem("role"));
          }
          // this.identity_s = this.identity_arr[0].Name;
          // sessionStorage.setItem(
          //   "role",
          //   JSON.stringify(this.identity_arr[0].Name)
          // );

          // store.dispatch("current/campus", res.School.Name);
        }
      });
    }

    // this.userInfo.user_role.forEach((res) => {
    //   if (res.Subject.Name == "ADMIN") {
    //     getSchool().then((res) => {
    //       this.campusList = res.data;
    //       console.log(res.data);
    //       if (this.current == "登录") {
    //         store.dispatch("current/campus", this.campusList[0].Name);
    //         localStorage.setItem("school_id", this.campusList[0].Id);
    //       }
    //     });
    //   } else {
    //     if (res.Domain.Group == "SCHOOL") {
    //       this.schoolList.push(res.Domain);
    //       let obj = {};
    //       let peon = this.schoolList.reduce((cur, next) => {
    //         obj[next.Name] ? "" : (obj[next.Name] = true && cur.push(next));
    //         return cur;
    //       }, []);
    //       this.campusList = peon;
    //       if (
    //         this.current == "登录" &&
    //         this.userInfo.user_role[0].Domain.Name != "ANY"
    //       ) {
    //         store.dispatch("current/campus", this.campusList[0].Name);
    //         localStorage.setItem("school_id", this.campusList[0].Id);
    //       }
    //     }
    //     if (res.Domain.Name == this.current) {
    //       this.identity_arr.push(res.Subject.Name);
    //       if (!sessionStorage.getItem("role")) {
    //         sessionStorage.setItem(
    //           "role",
    //           JSON.stringify(this.identity_arr[0])
    //         );
    //       }
    //       this.identity_s = JSON.parse(sessionStorage.getItem("role"));
    //     }
    //   }
    // });
  },

  methods: {
    selectPath(v) {
      this.$router.push({ path: v });
    },

    //切换校区
    switching_campuses() {
      this.campus_isible = true;
      this.school_value = this.current;
    },

    //选择校区对话框确定按钮
    campus_determine() {
      store.dispatch("current/campus", this.school_value);
      this.campus_isible = false;
      this.identity_s = [];
      this.identity.forEach((value) => {
        if (value.Domain.Name == this.current) {
          this.identity_s = value.Subject.Name;
          sessionStorage.setItem("role", JSON.stringify(value.Subject.Name));
        }
      });
    },

    //切换角色事件
    handleCommand(command) {
      this.identity_s = command.Name;
      sessionStorage.setItem("role", JSON.stringify(command.Name));

      // this.userInfo.user_role.forEach((value) => {
      //   if (value.Domain.Name == this.current) {
      //     this.identity_arr.push(value.Subject.Name);
      //     sessionStorage.setItem("role", JSON.stringify(this.identity_arr[0]));
      //     console.log(this.identity_arr)

      //   }
      // });
    },

    //切换校区事件
    handleSchool(command) {
      this.identity_arr = [];
      this.identity_s = "";
      store.dispatch("current/campus", command.Name);
      localStorage.setItem("school_id", command.Id);

      this.userInfo.SchoolRoles.forEach((res) => {
        if (res.School.Id == command.Id) {
          this.identity_arr.push(res.Role);
          this.identity_s = this.identity_arr[0].Name;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-menu {
  height: 100%;
  border: none;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.imagDiv {
  width: 100%;
  background: #323c57;
  text-align: center;
  overflow: hidden;

  p {
    margin-bottom: 18px;
    font-family: cursive;
    font-size: 22px;
    color: #fff;
  }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}

.title_logo {
   background:#ffb100;
   height: 60px;
   position:relative;
   img {
      width:74%;
      position:absolute;
      top:50%;
      left:50%;
      transform: translate(-50%, -50%);
   }
}

.identity_class {
  width:100%;
  overflow hidden
  border-bottom:1px solid #f6f6f6;
  p {
    font-size:14px;
    margin:12px;
    display:block;
    padding-bottom:12px;
    color:#333;
    font-size:12px;
    span {
      color:#999;
    }
  }
    p:nth-child(1) {
      border:none;
    }
}

.el-link {
  font-size:12px;
  margin-left:6px;
}

.el-dropdown-link {
  font-size:12px;
}
</style>

<style lang="stylus">
.el-menu-item .is-active {
  color: red !important;
}

.el-menu-item-group__title {
  background: red;
  padding: 0px;
}

.el-menu--popup {
  padding: 0px;
}
</style>
